export default {
  validate: (email, contractEmails) => !contractEmails.includes(email),
}
